const config = {
	API_URL: process.env.REACT_APP_API_URL || 'http://localhost:4003',
	baseURL: process.env.REACT_APP_API_URL || 'http://localhost:4003',
	GMSbaseURL: 'http://localhost:5012',
}

export default config
